<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>Sustentabilidade e solidariedade</h2>
          <p>
            Lançamento do <strong>Fundo JBS Pela Amazônia</strong>, dedicado a
            fomentar e financiar iniciativas e projetos que visam ao
            desenvolvimento sustentável do Bioma Amazônia, promovendo a
            conservação e o uso sustentável da floresta, a melhoria da qualidade
            de vida da população que nela reside e o desenvolvimento com uso de
            tecnologia e ciência aplicada.
          </p>
          <p>
            A JBS lança também o programa <strong>Fazer o Bem Faz Bem</strong>,
            dedicado a promover ações para transformação e apoio social com
            grande impacto durante a pandemia do novo coronavírus.
          </p>
          <p>
            A JBS USA conclui a aquisição de participação acionária na
            <strong>Empire Packing Company, L.P</strong>.
          </p>
        </div>
        <div class="formato__warpper__item--image">
          <img
            src="../assets/img/2020/2020-1.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2020/03/12/g/20200312-46167-nac-1-pri-a1-not-qapkakh.jpg'
              )
            "
            class="fistItem"
          />
          <img
            src="../assets/img/2020/2020-2.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2021/01/01/g/20210101-46462-nac-17-999-h1-not-spagkhk.jpg'
              )
            "
            class="secondItem"
          />
          <img
            src="../assets/img/2020/2020-3.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2020/06/05/g/20200605-46252-nac-26-eco-b10-not-gkggsgk.jpg'
              )
            "
            class="terceiroItem"
          />
          <img
            src="../assets/img/2020/2020-4.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2020/09/24/g/20200924-46363-nac-31-eco-b14-not-aaeekek.jpg'
              )
            "
            class="quartoItem"
          />

          <span
            ><i class="icon-eye"></i
            ><strong>clique nas imagens para ampliar</strong></span
          >
        </div>
        <div class="formato__warpper__item--black">
          <h2>Pandemia impulsiona <i>delivery</i> e <i>dark kitchen</i></h2>
          <p>
            Descoberto no final de 2019, um novo vírus se espalhou pelo mundo,
            causando a maior crise sanitária dos últimos cem anos. Era a
            <strong>covid-19</strong>, que se transformou em poucos meses em
            pandemia global. No Brasil, a pandemia mudou os hábitos de
            alimentação da população: sem poder frequentar restaurantes e tendo
            que trabalhar de casa, muita gente recorreu aos alimentos
            congelados, muitos deles saudáveis e/ou sustentáveis, e aos pedidos
            de <i>delivery</i> para fazer suas refeições.
          </p>
          <p>
            Foram destaque também as <strong><i>dark kitchens</i></strong
            >, cozinhas surgidas apenas para atender aplicativos de entrega em
            domicílio.
          </p>
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from "./Ano.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { defineComponent } from "vue";

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ["ano"],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, "_blank");
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 100px;
    display: grid;
    grid-template-columns: 520px 270px 1fr;
    gap: 10px;
    @include media("<=desktop") {
      grid-template-columns: 1fr;
    }
  }
  &__warpper {
    position: relative;

    &__item {
      position: relative;
      @include media("<=desktop") {
        padding: 0 20px;
      }
      &--image {
        position: relative;
        padding-top: 16px;
        gap: 36px;
        max-height: 600px;
        @include media("<=desktop") {
          padding: 0 20px;
        }
        img {
          display: block;
          transition: 0.3s ease-in-out;
          cursor: pointer;

          &:hover {
            transform: scale(1.1);
          }
        }
        .fistItem {
          margin-left: auto;
        }
        .secondItem {
          margin-top: -100px;
        }

        .terceiroItem {
          margin-left: auto;
          margin-top: -150px;
        }

        span {
          display: block;
          margin: 0 auto;
          width: 65px;
          color: color(cBlue);
          position: absolute;
          top: 20px;
          @include media(">desktop") {
            left: -30px;
          }
          strong {
            color: color(cWhite);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cBlue);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
      }
      h2 {
        color: color(primary);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cText);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
      }

      &--black {
        padding-right: 50px;
        margin-left: 30px;
        @include media("<=desktop") {
          padding: 30px 20px;
          margin: 0;
          background: color(cBlue5);
          margin-top: 30px;
        }
        p {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
          margin-top: 15px;
        }
        h2 {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          margin-bottom: 10px;
          margin-top: 15px;
        }
        blockquote {
          color: color(cBlue);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          margin: 10px 0;
          position: relative;
          &::before {
            content: "\e901";
            font-family: "icomoon" !important;
            display: block;
            font-size: 1rem;
            line-height: initial;
            margin-bottom: 17px;
          }
        }
      }
    }
    &::after {
      content: "";
      background: color(cBlue5);
      width: 37%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media("<=desktop") {
        display: none;
      }
    }
  }
}
</style>
